import React from "react";
import {
	Button
} from "@mui/material";
import {
	makeStyles
} from "@mui/styles";
import {Link} from "react-router-dom";
import {getImage} from "../../../../../utils/image";

const ServiceCard = ({ item }) => {
	const classes = useStyles();
	return (
		<Button className={classes.card} component={Link} to={`/services/${item.slug}`}>
			<div className={classes.cardImage}>
				<img src={getImage(item.icon_id, {width: 32, height: 32})} />
			</div>
			<div className={classes.cardName}>{item.name}</div>
		</Button>
	)
}

const useStyles = makeStyles(theme => ({
	card: {
		gap: "8px",
		width: "100%",
		padding: "6px",
		display: "flex",
		borderRadius: "8px",
		alignItems: "center",
		boxSizing: "border-box",
		justifyContent: "flex-start",
		background: `${theme.palette.background.default}!important`,
	},
	cardImage: {
		width: 32,
		height: 32,

		"& img": {
			width: "100%",
			height: "100%",
			objectFit: "contain",
			objectPosition: "center center",
		}
	},
	cardName: {
		fontSize: 16,
		color: "#E7E6E6",
		fontWeight: "500",
		lineHeight: "20px",
		letterSpacing: "0.02em",
	},
}));

export default ServiceCard;
